import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "PageScroll"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M18.7471 9.74743H20.2471V3.74743C20.2714 3.34264 20.1212 2.9468 19.8344 2.66005C19.5477 2.3733 19.1519 2.2231 18.7471 2.24743H12.7471V3.74743H18.7471V9.74743ZM18.7471 13.4974V11.9974H23.2471V16.4974H21.7471V14.6974L18.1471 18.7474H20.2471V20.2474H15.7471V15.7474H17.2471V17.5474L20.8471 13.4974H18.7471ZM15.7471 13.4974H17.2471V6.74743C17.2714 6.34264 17.1212 5.9468 16.8344 5.66005C16.5477 5.3733 16.1519 5.2231 15.7471 5.24743H8.24707V6.74743H15.7471V13.4974ZM2.99963 21H11.9996C12.4044 21.0243 12.8003 20.8741 13.087 20.5874C13.3738 20.3006 13.524 19.9048 13.4996 19.5V10.5C13.524 10.0952 13.3738 9.69937 13.087 9.41262C12.8003 9.12587 12.4044 8.97566 11.9996 8.99999H2.99963C2.59483 8.97566 2.199 9.12587 1.91225 9.41262C1.6255 9.69937 1.47529 10.0952 1.49963 10.5V19.5C1.47529 19.9048 1.6255 20.3006 1.91225 20.5874C2.199 20.8741 2.59483 21.0243 2.99963 21ZM2.99975 19.5V10.5H11.9997V19.5H2.99975Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/PageScroll.vue"]]);
